/**
 * A class representing an attachment and its metadata
 */
export class Attachment {
    /**
     * Create a new Attachment
     * @param {string} fileTag
     * @param {string} topic
     * @param {string} user
     * @param {string} date
     * @param {string} name
     * @param {string} userId
     */
    constructor(
        fileTag,
        topic,
        user,
        date,
        name,
        userId,
    ) {
        this._file = fileTag;
        this._topic = topic;
        this._user = user;
        this._date = date;
        this._name = name;
        this._userId = userId;
    }

    /**
     * Get all the information about an attachment, in a JS object
     * @return {{date: string, file: string, name: string, topic: string, user: string}}
     */
    getAttachment() {
        return {
            file: this._file,
            topic: this._topic,
            user: this._user,
            date: this._date,
            name: this._name,
            userId: this._userId,
        };
    }

    /**
     * Get the file value.
     * @return {string} The file value.
     */
    get file() {
        return this._file;
    }

    /**
     * Set the file value.
     * @param {string} value to set
     */
    set file(value) {
        this._file = value;
    }

    /**
     * Get the topic value.
     * @return {string} The topic value.
     */
    get topic() {
        return this._topic;
    }

    /**
     * Set the topic value.
     * @param {string} value to set
     */
    set topic(value) {
        this._topic = value;
    }

    /**
     * Get the user value.
     * @return {string} The user value.
     */
    get user() {
        return this._user;
    }

    /**
     * Set the user value.
     * @param {string} value to set
     */
    set user(value) {
        this._user = value;
    }

    /**
     * Get the date value.
     * @return {string} The date value.
     */
    get date() {
        return this._date;
    }

    /**
     * Set the date value.
     * @param {string} value to set
     */
    set date(value) {
        this._date = value;
    }

    /**
     * Get the name value.
     * @return {string} The name value.
     */
    get name() {
        return this._name;
    }

    /**
     * Set the name value.
     * @param {string} value to set
     */
    set name(value) {
        this._name = value;
    }

    /**
     * Get the user Id value.
     * @return {string} The user Id value.
     */
    get userId() {
        return this._userId;
    }

    /**
     * Set the user Id value.
     * @param {string} value to set
     */
    set userId(value) {
        this._userId = value;
    }
}
